module.exports = __webpack_public_path__ + "img/2c.7fe0b4b1.svg";